import { render, staticRenderFns } from "./IconWarningTriangle.vue?vue&type=template&id=6796e747&"
import script from "./IconWarningTriangle.vue?vue&type=script&lang=js&"
export * from "./IconWarningTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports